import * as React from "react";
import { P, Content, H1 } from "../recurso_literario.js";
import { useContext } from "react";
import { DomainContext } from "../../Context/Context.js";

function Bienvenido(props){
	const { cloudName } = useContext(DomainContext)
	  
    return (
        <Content>
			<H1> ¡Bienvenido! </H1>
			<P>
				{cloudName} es una nube que te permitirá desplegar tus aplicaciones
				y armar tus soluciones a tu medida. Te ofrece un abanico de elementos
				de nube que iremos ampliando con el tiempo.
			</P>
			<P>
				La solución es mediante la modalidad pago por uso. Ésto significa que en
				tu factura a fin de mes sólo te vendrá el monto por lo que has consumido.
				A diferencia de otras nubes públicas, verás que con {cloudName} tendrás
				una mayor predictibilidad del monto que vendrá en tu factura.
			</P>
			<P>
				La ayuda de {cloudName} no sólo te mostrará como utilizar el servicio,
				sino que te explicará conceptos de nube y algunos propios de ésta solución.
			</P>
			<P>
                Navegando por el panel de la izquierda se pueden encontrar todos los temas necesarios
                para el uso y manejo correctos de {cloudName}.
			</P>
        </Content>
    )
}

export default Bienvenido
